import React from "react";

const CheckBoxChecked = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none" {...props}>
    <g clip-path="url(#clip0_8844_21804)">
      <rect y="0.5" width="20" height="20" rx="2" fill="#3362AB" />
      <rect x="0.5" y="1" width="19" height="19" stroke="#3362AB" />
      <path
        d="M16.1231 4.68117C15.5675 4.32035 14.7869 4.43186 14.3805 4.92544L8.07447 12.6125L5.97556 10.2493C5.54786 9.76933 4.76387 9.68764 4.22434 10.0663C3.68316 10.4449 3.59209 11.1436 4.01817 11.6219L8.15369 16.2812L16.3958 6.22999C16.8023 5.73477 16.6804 5.042 16.1231 4.68117Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_8844_21804">
        <rect y="0.5" width="20" height="20" rx="2" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default CheckBoxChecked;
